import { State } from "@progress/kendo-data-query";
import { RefObject } from "react";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { MenuItem } from "@mui/material";
import axios from "axios";
import { ToolbarDropdownMenu } from "../../../Grid/Toolbar/ToolbarDropdownMenu";
import ExcelExportButton from "../../../Grid/ExcelExport/ExcelExportButton";
import { BidPackOverviewItem } from "../BidPackOverviewItem";
import { bidPackStateAsStringFirstLetter } from "../BidPackState";
import { transportTypeAsString } from "../TransportTypes";
import { defaultDateFormatDDMMYYYYSeperatedByPeriod, formatDateTo } from "../../../Utils/dates";
import { KENDO_BUTTON_CLASSES } from "../../../Layout/Buttons/KendoButtons";
import { UppercaseButton } from "../../../Layout/Buttons/UppercaseButton";
import { IconWithRightMargin } from "../../../Layout/Icons/IconWithRightMargin";
import { useExportWithToast } from "../../../Grid/ExcelExport/useExportWithToast";
import { combinedUrls } from "../../../URL/functions";
import { bidPackUrls } from "../../../URL/ApplicationUrls";
import RenderAuthorized from "../../../Auth/RenderAuthorized";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

export const BidPackOverviewToolbarMenu = (url: string) =>
  function BidPackExportMenu(dataState: State, { current }: RefObject<any>) {
    const exportBidPackDetails = useExportWithToast(
      () =>
        axios.get(combinedUrls(bidPackUrls.base.apiUrl, "BidPackDetailsReport"), {
          responseType: "blob",
        }),
      "Exporting Bid Pack Details"
    );

    return (
      <RenderAuthorized requiredRoles={AuthorizationPolicies.RequireAdminReadOnlyNetworkRiskLaunch}>
        <ToolbarDropdownMenu text="Exports" key="bidpack-overview-export-menu">
          <MenuItem>
            <ExcelExportButton
              url={url}
              dataState={dataState}
              columns={current?.columns.slice(0)}
              fileName="BidPacks"
              exportMapping={(bidPack: BidPackOverviewItem) => ({
                ...bidPack,
                RateAgreementStatus: bidPackStateAsStringFirstLetter.get(
                  bidPack.RateAgreementStatus
                ),
                TransportType: transportTypeAsString.get(bidPack.TransportType),
                StartDate: formatDateTo(
                  bidPack.StartDate,
                  defaultDateFormatDDMMYYYYSeperatedByPeriod
                ),
                EndDate: formatDateTo(bidPack.EndDate, defaultDateFormatDDMMYYYYSeperatedByPeriod),
              })}
            />
          </MenuItem>
          <MenuItem>
            <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={exportBidPackDetails}>
              <IconWithRightMargin icon={faList} />
              Export Bid Pack Details
            </UppercaseButton>
          </MenuItem>
        </ToolbarDropdownMenu>
      </RenderAuthorized>
    );
  };
